import { render, staticRenderFns } from "./StakingSummary.vue?vue&type=template&id=ad438aaa&scoped=true&"
import script from "./StakingSummary.vue?vue&type=script&lang=ts&"
export * from "./StakingSummary.vue?vue&type=script&lang=ts&"
import style0 from "./StakingSummary.vue?vue&type=style&index=0&id=ad438aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad438aaa",
  null
  
)

export default component.exports